// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__gwHGL","col":"styles_col__2JUzH","fulfillmentStatus":"styles_fulfillmentStatus__vWaZB","emailCol":"styles_emailCol__3tlq7"};